// extracted by mini-css-extract-plugin
export default {"Content":"ConfirmModal_Content__T9WUf","Warning":"ConfirmModal_Warning__OWIxz","SelectedLaws":"ConfirmModal_SelectedLaws__7-uxq","ButtonRow1":"ConfirmModal_ButtonRow1__Ct8PB"};